module.exports = __webpack_public_path__ + "static/media/details-2.4dc093ee.jpeg";